import React, { useContext } from "react";
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	useMediaQuery,
	useTheme,
	TableContainer,
	TableFooter,
	LinearProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Layers as LayersIcon } from "lucide-react";
// import Loading from "../../../components/loading";

import { ContextRegisterProduct } from "../context";
import CustomPagination from "../../../../components/paginate";
import libFloat from "../../../../util/libFloat";

const itemsPerPage = 15; // Quantidade de itens por página

function TableProducts(props) {
	const {
		// openModalProduct,
		handleOpenModalRegister,
		handleOpenModalVariants,
		nextFetch,
		productsData,
		page,
		setPage,
		totalPage,
		currentPage,
		loading,
	} = useContext(ContextRegisterProduct);

	const handleChangePage = (event, newPage) => {
		//se a pagina que chamei for > que a pagina que estou
		if (newPage > currentPage.current) {
			if (totalPage === 0) nextFetch(newPage); //se não chegou no fim da pagina
		}

		setPage(newPage);
	};

	// if (totalPage > 0) { //se tem um final ja definido de dados e chegou nele
	// 	if (newPage > totalPage) return; //e se a pagina que eu
	// }

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = productsData.slice(startIndex, endIndex);

	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<>
			{/* <Paper> */}
			<TableContainer component={Paper}>
				<Table>
					<TableHead className="color-table">
						<TableRow>
							<TableCell>
								<span className="text-color-table">Descrição</span>
							</TableCell>
							<TableCell
								style={{
									textAlign: "center",
									verticalAlign: "middle",
								}}
							>
								<span className="text-color-table">Valor</span>
							</TableCell>
							<TableCell
								style={{
									// width: "40px",
									textAlign: "center",
									verticalAlign: "middle",
								}}
							>
								<span className="text-color-table">Estoque</span>
							</TableCell>
							{!isSmallScreen && (
								<>
									<TableCell
										style={{
											textAlign: "center",
											verticalAlign: "middle",
										}}
									>
										<span className="text-color-table">Ean</span>
									</TableCell>
									<TableCell
										style={{
											// width: "40px",
											textAlign: "center",
											verticalAlign: "middle",
										}}
									>
										<span className="text-color-table">Referência</span>
									</TableCell>
								</>
							)}
							<TableCell
								style={{
									textAlign: "center",
									verticalAlign: "middle",
								}}
							>
								{/* <span className="text-color-table">valor</span> */}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{slicedData.map((item) => (
							<TableRow key={item.id_produto} className="zebra-row">
								<TableCell>
									<div className="flex items-center gap-2">
										<span>{item.nome}</span>
										{item.tem_grade && (
											<span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold bg-green-100 text-green-700 border border-green-300 leading-none whitespace-nowrap">
												Grade
											</span>
										)}
									</div>
								</TableCell>
								<TableCell
									style={{
										textAlign: "center",
										verticalAlign: "middle",
									}}
								>
									{libFloat.strToCurrency(item.valor)}
								</TableCell>
								<TableCell
									style={{
										textAlign: "center",
										verticalAlign: "middle",
									}}
								>
									{item.qtatual}
								</TableCell>

								{!isSmallScreen && (
									<>
										<TableCell
											style={{
												// width: "40px",
												textAlign: "center",
												verticalAlign: "middle",
											}}
										>
											{item.ean}
										</TableCell>

										<TableCell
											style={{
												// width: "40px",
												textAlign: "center",
												verticalAlign: "middle",
											}}
										>
											{item.referencia}
										</TableCell>
									</>
								)}
								<TableCell
									style={{
										textAlign: "center",
										verticalAlign: "middle",
									}}
								>
									<div className="flex justify-center gap-2">
										<button
											className="btn btn-sm btn-outline-primary"
											onClick={() => handleOpenModalRegister(item)}
											title="Editar Produto"
										>
											<EditIcon />
										</button>
										<button
											className={`btn btn-sm ${item.tem_grade ? "btn-success" : "btn-outline-success"}`}
											onClick={(e) => handleOpenModalVariants(item)}
											title={item.tem_grade ? "Editar Grade / Variações" : "Gerar Grade / Variações"}
										>
											<LayersIcon size={18} />
										</button>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
					{loading ? (
						<TableFooter>
							<TableRow>
								<TableCell colSpan={document.querySelectorAll("thead th").length}>
									<LinearProgress variant="indeterminate" />
								</TableCell>
							</TableRow>
						</TableFooter>
					) : (
						productsData.length === 0 && (
							<TableBody>
								<TableRow>
									<TableCell
										colSpan={document.querySelectorAll("thead th").length}
										className="italic text-gray-400"
									>
										Nenhum registro encontrado.
									</TableCell>
								</TableRow>
							</TableBody>
						)
					)}
				</Table>

				{/* {loading && (
					<div className="flex h-44">
						<Loading mensagem={"Carregando dados dos produtos"} />
					</div>
				)} */}
				{productsData?.length > 0 && (
					<CustomPagination
						count={Math.ceil(productsData.length / itemsPerPage)}
						page={page}
						onChangePage={handleChangePage}
						totalRecord={productsData.length}
						totalPage={totalPage}
					/>
				)}
			</TableContainer>
		</>
	);
}

export default TableProducts;
